module.exports = __webpack_public_path__ + "fonts/f6807ae0795edb7bcac9d136a405c29f-Audiowide-Regular.woff2";